export const ROOT_DOMAIN_DEV = 'keee.dev'
export const ROOT_DOMAIN_PROD = 'keee.app'

export function isRootDomain() {
  const { hostname } = window.location
  return [ROOT_DOMAIN_DEV, ROOT_DOMAIN_PROD].includes(hostname) || hostname.includes('.ngrok.io')
}
